import { render, staticRenderFns } from "./TyyDetailTable.vue?vue&type=template&id=3cb385c9&"
import script from "./TyyDetailTable.vue?vue&type=script&lang=js&"
export * from "./TyyDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./TyyDetailTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports